export default __webpack_public_path__ + "images/Piphoat-Reangsei.webp";